(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-o2o-tabs]').forEach(section => {
      if (section.dataset.tabsReady) return;
      section.dataset.tabsReady = 'true';
      const tabs = [...section.querySelectorAll('[data-o2o-tab]')];
      const show = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
        document.dispatchEvent(new CustomEvent('o2o:content-updated', {detail: {root: section}}));
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => show(tab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) { event.preventDefault(); show(target, true); }
        });
      });
      if (tabs[0]) show(tabs[0]);
    });
    root.querySelectorAll('[data-o2o-focus]').forEach(section => {
      if (section.dataset.focusReady) return;
      section.dataset.focusReady = 'true';
      const slides = [...section.querySelectorAll('[data-focus-slide]')];
      const track = section.querySelector('.focus-product-card');
      const mobile = window.matchMedia('(max-width: 767px)');
      let index = 0;
      const syncLayout = () => {
        slides.forEach((slide, i) => slide.hidden = !mobile.matches && i !== index);
        if (track) {
          track.setAttribute('aria-live', mobile.matches ? 'off' : 'polite');
          if (!mobile.matches) track.scrollLeft = 0;
        }
      };
      const change = direction => {
        if (!slides.length) return;
        index = (index + direction + slides.length) % slides.length;
        syncLayout();
      };
      section.querySelector('[data-o2o-focus-prev]')?.addEventListener('click', () => change(-1));
      section.querySelector('[data-o2o-focus-next]')?.addEventListener('click', () => change(1));
      mobile.addEventListener('change', syncLayout);
      syncLayout();
    });
  };
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
